<script lang="ts">
    import { blur } from 'svelte/transition';
    import { _ } from 'svelte-i18n';
    import Sortable from '../../../utilities/sortable';

    import { type RoutePointExtendedType } from '../../../utilities/RoutePointsApi';
    import { type ReorderedRouteType } from '../AssignmentApi';
    import MessageDanger from '../../../shared/Messages/MessageDanger.svelte';
    import { onMapReady } from '../../../utilities/onMapReady';
    import Spinner from '../../../shared/Spinner/Spinner.svelte';
    import type { JobCountType } from '../../Jobs/types';
    import { PlanningOnMap } from '../PlanningOnMap';
    import { AssignmentApi } from '../AssignmentApi';
    import { debug, deliveryList, leftPageWidthPx } from '../../../../stores/store';
    import { afterUpdate, onMount } from 'svelte';
    import { api } from '../../../../stores/api';
    import { Assignment } from '../Assignment';
    import { get } from 'svelte/store';
    import { openModal } from 'svelte-modals';
    import ModalInfo from '../../../shared/Modals/ModalInfo.svelte';
    import ModalUnsavedRoute from '../../Modals/ModalUnsavedRoute.svelte';
    import { Navigation } from '../../../utilities/Navigation';
    import { features } from '../../../shared/Features/features';
    import RoutePointWithAssignments from './RoutePointWithAssignments.svelte';
    import AssignmentJobOneHeader from './AssignmentJobOneHeader.svelte';
    import AssignmentJobOneWarehouse from './AssignmentJobOneWarehouse.svelte';
    import { Address } from './Address';
    import { WarehouseApi } from '../../Warehouses/WarehouseApi';
    import { Warehouse } from '../../Warehouses/Warehouse';
    import { vehiclesManager } from '../../Vehicles/VehiclesApp/vehiclesManager';
    import { RouteSummaryApp } from './RouteSummaryApp/RouteSummaryApp';
    import { dla } from './DeliveryListApp/dla';
    import { rsa } from './RouteSummaryApp/rsa';
    import ModalError from '../../../shared/Modals/ModalError.svelte';
    import { AssignmentJobRejectionApi } from '../AssignmentJobRejectionApi';
    import { switchingBetweenTabsInProgress } from './store';
    import { GanttCouriersSettings } from '../../GanttCouriers/GanttCouriersSettings';
    import type { Vehicle } from '../../Vehicles/Vehicle';
    import { Umami } from '../../../utilities/Umami';

    export let assignment: Assignment;
    export let disabled: boolean = false;
    export let ganttCouriersSettings: GanttCouriersSettings;

    // let loading: boolean = true;
    let error: string = '';
    let routePoints: RoutePointExtendedType[] = [];
    let projectList: HTMLDivElement;

    let sortable: any = null;
    let firstSortable: number = 0;
    let routeDirty: boolean = false;
    let routeVariant: number = 0;

    let countTotal: JobCountType = { count: 0 };
    let countFiltered: JobCountType = { count: 0 };
    let planningOnMap: PlanningOnMap | null;
    let leaveMapObjects: boolean = false;
    let calculatingRouteInProgress: boolean = false;
    let recalculationInProgress: boolean = false;
    let routeHasBeenChangedAfterCalculation: boolean = false;
    let modifiedRouteData: ReorderedRouteType | null = null;
    let modifyActionInProgress: boolean = false;

    let componentMounted: boolean = false;

    let warehouseAddress: Address = new Address();
    let routeEndAddress: Address | null = null;

    let dataIdsDraggedElements: number[] = [];

    let stages: Record<number, {point_id: number, point_order: number, stage_idx: number, visible: boolean}> = {};
    let visiblePoints: RoutePointExtendedType[] = [];

    function getFilterAssignmentId() {
        return { assignment_id: { $in: [assignment.getId()] } };
    }

    function recalcRoute(order: (number|null)[] | null = null) {
        if (disabled) {
            console.warn('PlanningDeliveryRoute, recalcRoute, disabled');
            return;
        }
        if (planningOnMap && order) {
            let removedCounter = 0;
            for (let i = 0; i < order.length; i++) {
                if (order[i] === null) {
                    removedCounter++;
                } else if (order[i] >= 0 && !routePoints[i-removedCounter].jobs && i > 0 && i < order.length - 1) {
                    order[i] = -1;
                }
            }
            planningOnMap.changeRoutePointsOrder(order, null);
        }
        routeVariant++;
        recalculationInProgress = true;
        AssignmentApi.reorderRoute(get(api), assignment.getId(), 'trace', {
            order: routePoints.map(p => p.id),
            variant: routeVariant,
            start_date: assignment.getStartDateRoute(),
        })
            .then(data => {
                console.log('PlanningDeliveryRoute, reorderRoute, data(1)', data);
                if (data.route) {
                    let routeInfo = assignment.getRouteInfo();
                    if (routeInfo) {
                        let routeStack = routeInfo.reorder_stack || [];
                        if (data.variant == routeVariant) {
                            modifiedRouteData = data.route;
                            routeStack.push(data.route);
                            routeInfo.reorder_stack = routeStack;
                            assignment.setRouteInfo(routeInfo);
                            assignment.setModifiedRouteData(modifiedRouteData);
                            assignment = assignment;
                            if (planningOnMap && order) {
                                planningOnMap.changeRoutePointsOrder(null, data.route.deltas);
                                planningOnMap.setRoute(data.route.id, routeInfo.route.id);
                            }
                            // if ($deliveryList.isRouteVariantVisible) {
                            $rsa.importRouteModifiedByOperator(assignment, $dla.getItems());
                            $rsa.getModifiedByOperatorRoute().isLoading = false;
                            $rsa = $rsa;
                            // }
                            routeDirty = false;
                            recalculationInProgress = false;
                            ganttCouriersSettings.tickCounter();
                            ganttCouriersSettings = ganttCouriersSettings;
                        }
                    }
                    /*assignment.setRouteCalculationStatus('completed');
                Promise.all([
                    AssignmentApi.getOneWithCounters(get(api), assignment.getId()),
                    RoutePointsApi.getPoints(get(api), assignment.getId()),
                ]).then( response => {
                    assignment.set(response[0]);
                    assignment = assignment;
                    routePoints = response[1];
                }).finally(() => {
                    calculatingRouteInProgress = false;
                    routeDirty = false;
                });*/
                } else {
                    console.log('PlanningDeliveryRoute, recalcRoute, data, else', data);
                    routeDirty = true;
                    //calculatingRouteInProgress = false;
                    recalculationInProgress = false;
                }
            })
            .catch(err => {
                console.log('PlanningDeliveryRoute, recalcRoute, err', err);
                openModal(ModalError, {
                    message: $_('Error while saving changes.'),
                });
                error = $_('recalculate_route_failed');
                //calculatingRouteInProgress = false;
                recalculationInProgress = false;
            })
            .finally(() => {
                ganttCouriersSettings.tickCounter();
                ganttCouriersSettings = ganttCouriersSettings;
            });
    }

    function unsavedChanges(): Promise<boolean> {
        if (disabled) {
            console.warn('PlanningDeliveryRoute, recalcRoute, disabled');
            return;
        }
        return new Promise<boolean>((resolve, reject) => {
            if (modifiedRouteData) {
                openModal(ModalUnsavedRoute, {
                    onClick: (action: string) => {
                        switch (action) {
                            case 'commit':
                                AssignmentApi.reorderRoute(get(api), assignment.getId(), 'commit', {
                                    start_date: assignment.getStartDateRoute(),
                                    variant: routeVariant - 1,
                                })
                                    .then(data => {
                                        resolve(true);
                                    })
                                    .catch(err => {
                                        openModal(ModalError, {
                                            message: $_('Error while saving changes.'),
                                        });
                                        console.error(
                                            'PlanningDeliveryRoute, commitChanges, err',
                                            err
                                        );
                                    });
                                break;
                            case 'discard':
                                AssignmentApi.reorderRoute(
                                    get(api),
                                    assignment.getId(),
                                    'discard',
                                    {}
                                )
                                    .then(data => {
                                        resolve(true);
                                    })
                                    .catch(err => {
                                        openModal(ModalError, {
                                            message: $_('Error while saving changes.'),
                                        });
                                        console.error(
                                            'PlanningDeliveryRoute, commitChanges, err',
                                            err
                                        );
                                    });
                                break;
                            case 'cancel':
                                resolve(false);
                                break;
                        }
                    },
                });
            } else {
                resolve(true);
            }
        });
    }

    async function commitChanges() {
        /*if (disabled) {
            console.warn('PlanningDeliveryRoute, recalcRoute, disabled');
            return;
        }*/
        console.log('modified-by-operator-confirm, commitChanges');
        $rsa.getModifiedByOperatorRoute().isLoading = true;
        dataIdsDraggedElements = [];
        modifyActionInProgress = true;
        planningOnMap?.setRoute(modifiedRouteData?.id || '', null);
        await AssignmentApi.reorderRoute(get(api), assignment.getId(), 'commit', {
            start_date: assignment.getStartDateRoute(),
            variant: routeVariant - 1,
        }).catch(err => {
            openModal(ModalError, {
                message: $_('Error while saving changes.'),
            });
            console.error('PlanningDeliveryRoute, commitChanges, err', err);
        });
        await reloadData(true);
        modifyActionInProgress = false;
        $rsa.getModifiedByOperatorRoute().isLoading = false;
        $deliveryList.isRouteVariantVisible = false;
        assignment = assignment;
        $rsa = $rsa;
    }

    async function discardChanges() {
        /*if (disabled) {
            console.warn('PlanningDeliveryRoute, recalcRoute, disabled');
            return;
        }*/
        $rsa.getModifiedByOperatorRoute().isLoading = true;
        dataIdsDraggedElements = [];
        modifyActionInProgress = true;
        //planningOnMap?.setRoute(assignment.getRouteInfo()?.route.id || '', null);
        planningOnMap?.reload();
        await AssignmentApi.reorderRoute(get(api), assignment.getId(), 'discard', {}).catch(err => {
            openModal(ModalError, {
                message: $_('Error while saving changes.'),
            });
            console.error('PlanningDeliveryRoute, commitChanges, err', err);
        });
        await reloadData(true);
        modifyActionInProgress = false;
        $rsa.getModifiedByOperatorRoute().isLoading = false;
        $deliveryList.isRouteVariantVisible = false;
        assignment = assignment;
        $rsa = $rsa;
    }

    function undoChanges() {
        if (disabled) {
            console.warn('PlanningDeliveryRoute, recalcRoute, disabled');
            return;
        }
        modifyActionInProgress = true;
        let routeInfo = assignment.getRouteInfo();
        if (routeInfo && routeInfo.reorder_stack && routeInfo.reorder_stack.length) {
            if (routeInfo.reorder_stack.length > 1) {
                routeInfo.reorder_stack.pop();
                modifiedRouteData = routeInfo.reorder_stack[routeInfo.reorder_stack.length - 1];
                assignment.setModifiedRouteData(modifiedRouteData);
                if (modifiedRouteData) {
                    let order: number[] = [];
                    let pts: any = {};
                    for (let p of routePoints) {
                        pts[p.id] = p;
                    }
                    let newRoutePoints = [];
                    for (let p of modifiedRouteData.order) {
                        order.push(pts[p].point_order);
                        pts[p].point_order = newRoutePoints.length;
                        newRoutePoints.push(pts[p]);
                    }
                    routePoints = [...newRoutePoints];
                    $dla.setRoutePoints(routePoints);
                    $dla = $dla;
                    if (planningOnMap) {
                        planningOnMap.setRoute(modifiedRouteData.id, routeInfo.route.id);
                        planningOnMap.changeRoutePointsOrder(order, modifiedRouteData.deltas);
                    }
                }
                routeVariant--;
                assignment.setRouteInfo(routeInfo);
                assignment = assignment;
                AssignmentApi.reorderRoute(get(api), assignment.getId(), 'undo', {
                    variant: routeVariant,
                }).catch(err => {
                    openModal(ModalError, {
                        message: $_('Error while saving changes.'),
                    });
                    console.error('PlanningDeliveryRoute, commitChanges, err', err);
                });
            } else {
                discardChanges();
            }
            modifyActionInProgress = false;
        } else {
            modifyActionInProgress = false;
        }
    }

    function addMapPlanningSupport() {
        if (componentMounted) {
            let planningOnMapConfig = {
                queries: {},
                scenarioId: assignment.getScenarioId(),
                selectedAssignment: assignment,
                showRoute: $rsa.selectedRouteType,
                assignmentTypes: null,
                assignmentQuery: null,
            };
            if (assignment.getId() > 0) {
                planningOnMapConfig.assignmentTypes = { unassigned: false, suggestions: false };
            } else {
                planningOnMapConfig.assignmentQuery = getFilterAssignmentId();
            }
            planningOnMap = new PlanningOnMap(planningOnMapConfig);
            if (assignment.getId() > 0) {
                planningOnMap.zoomToAssignment();
            } else {
                planningOnMap.zoomToAssignment(getFilterAssignmentId());
            }
            planningOnMap.addEventListener('jobclick', (evt: any) => {
                console.log('jobclick', evt.detail.jobId, evt.detail.ajId, evt.detail.assignmentId);
                // reassignJob(evt.detail.jobId, evt.detail.ajId, evt.detail.assignmentId);
            });
        }
    }

    async function reloadData(withMapSupport: boolean) {
        console.debug('PlanningDeliveryRoute, reloadData');
        $dla.loading = true;
        error = '';

        try {
            const [
                mapReady,
                assignmentData,
                realisationStatus,
                vehiclesData,
                extendedRoutePoints,
                rejectedJobs,
            ] = await Promise.all([
                onMapReady(),
                AssignmentApi.getOneWithCounters(get(api), assignment.getId()),
                assignment.isLocked() || assignment.isRouteModifiedAfterDownload()
                    ? AssignmentApi.getRealisationStatus(get(api), [assignment.getId()], true)
                    : null,
                $vehiclesManager.prepareData(),
                $dla.setApi(get(api)).setAssignmentId(assignment.getId()).loadExtendedRoutePoints(),
                AssignmentJobRejectionApi.getByAssignmentId(get(api), assignment.getId()),
            ]);

            routePoints = $dla.getRoutePoints();
            if (
                $rsa.selectedRouteType === 'current_in_realisation' &&
                assignment.getRouteInRealisation()
            ) {
                let filteredPoints = [];
                try {
                    // https://er.automapa.pl/issues/42573
                    let pointsInRealisation = assignment.getRouteInRealisation()?.points ?? [];
                    for (let i = 0; i < routePoints.length; i++) {
                        if (
                            pointsInRealisation.filter((p: any) => p.id === routePoints[i].id)
                                .length
                        ) {
                            filteredPoints.push(routePoints[i]);
                        }
                    }
                } catch (e) {
                    console.error('Error while filtering points in realisation', e);
                }
                routePoints = filteredPoints;
            }
            countFiltered = { count: routePoints.length - 2 };
            countTotal = { count: routePoints.length - 2 };

            assignment.set(assignmentData);
            if (realisationStatus) {
                assignment.updateRealisationStatus(realisationStatus[0]);
            }

            routeVariant = 0;
            modifiedRouteData = null;
            assignment.setModifiedRouteData(modifiedRouteData);

            if (!assignment.isRouteCalculated() && routePoints.length > 0) {
                routePoints = [];
                routeHasBeenChangedAfterCalculation = true;
                $dla.setRoutePoints(routePoints);
            } else if (assignment.getRouteInfo()?.reorder_stack?.length > 0) {
                modifiedRouteData =
                    assignment.getRouteInfo().reorder_stack[
                        assignment.getRouteInfo().reorder_stack.length - 1
                    ];
                assignment.setModifiedRouteData(modifiedRouteData);

                if (modifiedRouteData) {
                    let pts: any = {};
                    for (let p of routePoints) {
                        pts[p.id] = p;
                    }
                    routePoints = [];
                    for (let p of modifiedRouteData.order) {
                        if (p <= 0 && !pts[p]) {
                            pts[p] = JSON.parse(JSON.stringify(routePoints[0]));
                            pts[p].id = p;
                        }
                        pts[p].point_order = routePoints.length;
                        routePoints.push(pts[p]);
                    }
                    $dla.setRoutePoints(routePoints);
                    $rsa.importRouteModifiedByOperator(assignment, $dla.getItems());
                }
                routeVariant = assignment.getRouteInfo().reorder_stack.length;
            }

            stages = {};
            for (let i = 0; i < routePoints.length - 1; i++) {
                if (!routePoints[i].jobs) {
                    stages[routePoints[i].id] = {point_id: routePoints[i].id, point_order: routePoints[i].point_order, stage_idx: Object.keys(stages).length, visible: true};
                }
            }

            $dla.setAssignmentRejectedJobs(rejectedJobs);

            assignment = assignment;
            $dla.assignment = assignment;
            $dla = $dla;

            $rsa.setStopsQuantity(routePoints.length - 2);
            $rsa = $rsa;

            if (withMapSupport) {
                addMapPlanningSupport();
                if (modifiedRouteData && planningOnMap) {
                    let warehouses = 0;
                    let order = [];
                    for (let i = 0; i < routePoints.length; i++) {
                        if (routePoints[i].jobs || i == 0 || i == routePoints.length - 1) {
                            order.push(i - warehouses);
                        } else {
                            warehouses++;
                            order.push(-1);
                        }
                    }
                    let checkRouteInterval = setInterval(() => {
                        if (planningOnMap && PlanningOnMap.route) {
                            clearInterval(checkRouteInterval);
                            planningOnMap.changeRoutePointsOrder(order, modifiedRouteData.deltas);
                            planningOnMap.setRoute(
                                modifiedRouteData.id,
                                assignment.getRouteInfo()?.route?.id
                            );
                        }
                    }, 100);
                }
            }

            $dla.loading = false;
            $switchingBetweenTabsInProgress = false;
        } catch (err) {
            console.error(err);
            error = $_('fetch_deliveries_failed');
            $dla.loading = false;
            $switchingBetweenTabsInProgress = false;
        }
    }

    async function loadWarehouseData() {
        let warehouse: Warehouse;
        let warehouseId = (await $vehiclesManager.asyncGetItems())
            .find(v => v.getId() == assignment.getVehicleId())
            ?.getWarehouseId();
        if (warehouseId) {
            WarehouseApi.getOne(get(api), warehouseId)
                .then(data => {
                    warehouse = new Warehouse().set(data, null);
                    warehouseAddress.name = warehouse.getName();
                    warehouseAddress.street = warehouse.getStreet();
                    warehouseAddress.city = warehouse.getCity();
                    warehouseAddress.house = warehouse.getHouse();
                })
                .catch(err => {
                    console.log('PlanningDeliveryRoute, loadWarehouseData, err', err);
                });
        } else {
            alert('Warehouse not found');
        }

        // https://er.automapa.pl/issues/45084
        let vehicle: Vehicle | undefined = $vehiclesManager
            .getItems()
            .find(v => v.getId() == assignment.getVehicleId());
        if (vehicle) {
            let vd = vehicle.get();
            if (vd) {
                if (
                    vd.route_end &&
                    vd.route_end?.coordinates !== null &&
                    vd.route_end?.query &&
                    vd.route_end.query !== ''
                ) {
                    routeEndAddress = new Address();
                    routeEndAddress.name = vd.route_end?.query ?? '---';
                } else {
                    routeEndAddress = null;
                }
            }
        }
    }

    let addWarehouseState: ({index: number, timeout: any})|null = null;
    function onRoutePointMouseMove(evt: MouseEvent) {
        if (!assignment.isLocked() && !disabled && $features.feature_add_warehouse_in_the_middle_of_the_route) {
            const row = evt.target?.closest('.route-point-row');
            if (row) {
                const routePointId = row.getAttribute('data-route-point-id');
                const routePointIndex = routePoints.findIndex(rp => rp.id == routePointId);
                const pointOrderElement = row.querySelector('.checkbox');
                const rect = row.getBoundingClientRect();
                const mousePosition = {x: evt.clientX, y: evt.clientY};
                let insert = null;
                if (mousePosition.y - rect.top <= 5) {
                    if (routePointIndex > 1 && routePointIndex >= firstSortable && routePoints[routePointIndex-1].jobs) {
                        insert = 'before';
                    }
                } else if (rect.bottom - mousePosition.y <= 5) {
                    if (routePointIndex < routePoints.length - 2 && (routePointIndex + 1) >= firstSortable && routePoints[routePointIndex+1].jobs) {
                        insert = 'after';
                    }
                }
                let element = row.parentNode.querySelector('.insert-warehouse');
                if (insert) {
                    let index;
                    if (insert == 'before') {
                        index = routePointIndex;
                    } else {
                        index = routePointIndex + 1;
                    }
                    if (!addWarehouseState || addWarehouseState.index != index) {
                        if (addWarehouseState) {
                            clearTimeout(addWarehouseState.timeout);
                        }
                        addWarehouseState = {index: index, timeout: setTimeout(() => {
                            if (!element) {
                                element = document.createElement('div');
                                element.className = 'insert-warehouse';
                                element.innerHTML = `<div class="line"></div><div class="circle">M</div><div>${get(_)('insert_return_to_warehouse')}</div><div class="line"></div>`;
                                element.style.width = row.clientWidth+'px';
                                element.addEventListener('click', onAddWarehouse);
                                pointOrderElement.appendChild(element);
                            }
                            if (insert == 'before') {
                                element.style.top = '-10px';
                                element.setAttribute('data-warehouse-index', routePointIndex);
                            } else {
                                element.style.bottom = '-11px';
                                element.setAttribute('data-warehouse-index', routePointIndex + 1);
                            }
                        }, 1000)};
                    }
                } else {
                    if (element) {
                        element.remove();
                    }
                    if (addWarehouseState) {
                        clearTimeout(addWarehouseState.timeout);
                        addWarehouseState = null;
                    }
                }
            }
        }
    }

    function onRoutePointMouseLeave(evt: MouseEvent) {
        const row = evt.target?.closest('.point-draggable');
        if (row) {
            row.querySelector('.insert-warehouse')?.remove();
            if (addWarehouseState) {
                clearTimeout(addWarehouseState.timeout);
                addWarehouseState = null;
            }
        }
    }

    function onAddWarehouse(evt: MouseEvent) {
        evt.stopPropagation();
        let element = evt.target?.closest('.insert-warehouse');
        if (element) {
            routeDirty = true;
            let index = element.getAttribute('data-warehouse-index');
            element.remove();
            if (addWarehouseState) {
                clearTimeout(addWarehouseState.timeout);
                addWarehouseState = null;
            }
            let warehousePoint = JSON.parse(JSON.stringify(routePoints[0]));
            warehousePoint.id = Math.min(0, Math.min(...routePoints.map((p) => p.id))) - 1;
            routePoints.splice(index, 0, warehousePoint);
            let order = [];
            let newwarehouse = 0;
            for (let i = 0; i < routePoints.length; i++) {
                if (!routePoints[i].jobs && i > 0 && i < routePoints.length - 1) {
                    order.push(-1);
                    if (routePoints[i].id == warehousePoint.id) {
                        newwarehouse = 1;
                    }
                } else {
                    order.push(i - newwarehouse);
                }
                routePoints[i].point_order = i;
            }
            $dla = $dla.setRoutePoints(routePoints);
            $rsa.getModifiedByOperatorRoute().isLoading = true;
            $rsa = $rsa;
            stages[warehousePoint.id] = {point_id: warehousePoint.id, point_order: warehousePoint.point_order, stage_idx: index, visible: true};
            stages = stages;
            routePoints = routePoints;
            recalcRoute(order);
        }
    }

    function onRemoveWarehouse(index: number) {
        delete(stages[routePoints[index].id]);
        routeDirty = true;
        routePoints.splice(index, 1);
        let order = [];
        let removed = 0;
        for (let i = 0; i < routePoints.length; i++) {
            if (i == index) {
                order.push(null);
                removed++;
            }
            if (!routePoints[i].jobs && i > 0 && i < routePoints.length - 1) {
                order.push(-1);
            } else {
                order.push(i + removed);
            }
            routePoints[i].point_order = i;
        }
        $dla = $dla.setRoutePoints(routePoints);
        $rsa.getModifiedByOperatorRoute().isLoading = true;
        $rsa = $rsa;
        routePoints = routePoints;
        stages = stages;
        recalcRoute(order);
    }

    function onStageToggle(routePointIndex: number, expanded: boolean) {
        if (Object.keys(stages).length > 1) {
            let routePoint = routePoints.filter(p => p.point_order == routePointIndex)[0];
            if (routePoint && (routePoint.id in stages)) {
                stages[routePoint.id].visible = expanded;
                stages = stages;
            }
        }
    }

    function onStageShowExclusive(routePointIndex: number) {
        if (Object.keys(stages).length > 1) {
            let routePoint = routePoints.filter(p => p.point_order == routePointIndex)[0];
            if (routePoint && (routePoint.id in stages)) {
                for (let i in stages) {
                    if (stages[i].point_id != routePoint.id && stages[i].visible) {
                        onStageToggle(stages[i].point_order, false);
                    }
                }
                if (!stages[routePoint.id].visible) {
                    onStageToggle(routePoint.point_order, true);
                }
            }
        }
    }

    function isRoutePointDraggable(routePoint: RoutePointExtendedType): boolean {
        if (routePoint.point_order < firstSortable || routePoint.point_order == routePoints.length - 1) {
            return false;
        } else if (routePoint.jobs) {
            return true;
        } else {
            if (stages[routePoint.id]?.visible) {
                let warehousePointIds: number[] = Object.keys(stages).map((id) => parseInt(id));
                warehousePointIds.sort((a: number, b: number) => routePoints.filter(p => p.id == a)[0].point_order - routePoints.filter(p => p.id == b)[0].point_order);
                let warehouseIndex = warehousePointIds.indexOf(routePoint.id);
                return warehouseIndex > 0 && stages[warehousePointIds[warehouseIndex-1]].visible;
            } else {
                return false;
            }
        }
    }

    onMount(() => {
        Navigation.addListener('planning-route', unsavedChanges);
        componentMounted = true;
        $deliveryList.isRouteVariantVisible = false;
        reloadData(true);
        loadWarehouseData();

        $rsa.clearListeners();
        $rsa.setListener(RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_DISCARD, async () => {
            await discardChanges();
        });
        $rsa.setListener(RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_COMMIT, async () => {
            await commitChanges();
        });
        $rsa.setListener(RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_RECALCULATE, () => {
            routeDirty = true;
            $dla = $dla.setRoutePoints(routePoints);
            $rsa.getModifiedByOperatorRoute().isLoading = true;
            $rsa.setStopsQuantity(routePoints.length - 2);
            recalcRoute();
            return new Promise((resolve, reject) => {
                resolve();
            });
        });
        $rsa.setListener(RouteSummaryApp.ROUTE_MODIFIED_BY_OPERATOR_REVERSE, () => {
            if (!recalculationInProgress) {
                routeDirty = true;
                let reversedOrder = [0];
                let reversedPoints = [routePoints[0]];
                for (let i = routePoints.length - 2; i > 0; i--) {
                    reversedOrder.push(routePoints[i].point_order);
                    reversedPoints.push({...routePoints[i], point_order: reversedPoints.length});
                }
                reversedOrder.push(reversedOrder.length);
                reversedPoints.push(routePoints[routePoints.length-1]);
                routePoints = reversedPoints;
                $dla.setRoutePoints(reversedPoints);
                $rsa.getModifiedByOperatorRoute().isLoading = true;
                $rsa.setStopsQuantity(routePoints.length - 2);
                $rsa = $rsa;
                recalcRoute(reversedOrder);
            }
            return new Promise((resolve, reject) => {
                resolve();
            });
        });

        return () => {
            Navigation.removeListener('planning-route');
            componentMounted = false;
            if (planningOnMap) {
                planningOnMap.updateConfig({ showRoute: false });
                planningOnMap.destroy(leaveMapObjects);
                planningOnMap = null;
            }
            let routeInfo = assignment.getRouteInfo();
            if (routeInfo && routeInfo.reorder_stack) {
                routeInfo.reorder_stack = [];
                assignment.setRouteInfo(routeInfo);
                assignment = assignment;
                AssignmentApi.reorderRoute(get(api), assignment.getId(), 'discard', {}).catch(
                    err => {
                        openModal(ModalError, {
                            message: $_('Error while saving changes.'),
                        });
                        console.error('PlanningDeliveryRoute, commitChanges, err', err);
                    }
                );
            }
        };
    });

    afterUpdate(() => {
        if (!$dla.loading) {
            calculatingRouteInProgress = assignment.isRouteInCalculation();
            if (disabled) {
                console.warn('PlanningDeliveryRoute, Sortable, disabled');
            }
            if (
                assignment.isRouteTracable() &&
                !assignment.isLocked() &&
                routePoints.length &&
                $rsa.selectedRouteType !== 'current_in_realisation' &&
                projectList && !disabled
            ) {
                // https://github.com/SortableJS/Sortable
                sortable = Sortable.create(projectList, {
                    animation: 150,
                    draggable: '.point-draggable',
                    onMove: function (evt: any) {
                        const draggedEl = evt.dragged;
                        const relatedEl = evt.related;
                        const draggedIndex = parseInt(draggedEl.getAttribute('data-id'));
                        const relatedIndex = parseInt(relatedEl.getAttribute('data-id'));
                        const newIndex = relatedIndex + (evt.willInsertAfter ? 1 : 0);
                        if (draggedIndex != newIndex && draggedIndex != newIndex - 1) {
                            let routePoint = routePoints[draggedIndex];
                            let stagesSorted = Object.values(stages);
                            stagesSorted.sort((a, b) => a.point_order - b.point_order);
                            let currentStage = stagesSorted.filter((s) => draggedIndex >= s.point_order).pop();
                            let newStage = stagesSorted.filter((s) => newIndex > s.point_order).pop();
                            if (!routePoint.jobs && (currentStage.stage_idx > newStage.stage_idx +1 || currentStage.stage_idx < newStage.stage_idx)) {
                                //cannot move warehouse before or behind other warehouse
                                return false;
                            } else if (!newStage.visible) {
                                //cannot move warehouse to collappsed stage
                                return false;
                            }
                            const proposedOrder = [...routePoints];
                            proposedOrder.splice(newIndex, 0, routePoints[draggedIndex]);
                            for (let i = 1; i < proposedOrder.length; i++) {
                                if (!proposedOrder[i].jobs && !proposedOrder[i-1].jobs) {
                                    //two warehouses cannot be placed one after another
                                    return false;
                                }
                            }
                        }
                        return true;
                    },
                    onEnd: function (evt: any) {
                        console.log('draggable', firstSortable, routePoints.length);
                        if (assignment.isLocked()) {
                            openModal(ModalInfo, {
                                text: $_(
                                    'Route is locked. Unlock it first by clicking lock icon above.'
                                ),
                            });
                        } else {
                            // from div evt.item element get value from data-id
                            try {
                                dataIdsDraggedElements.push(
                                    parseInt(evt?.item?.getAttribute('data-route-point-id'))
                                );
                                dataIdsDraggedElements = dataIdsDraggedElements;
                            } catch (e) {
                                console.error(
                                    'Error while getting data-id from dragged element',
                                    e
                                );
                            }
                            let order = [...evt.to.querySelectorAll('div[data-id]')].map((e) => parseInt(e.getAttribute('data-id')));
                            console.log('sortable, order, onEnd, toArray', [...order]);
                            let stagesSorted = Object.values(stages);
                            stagesSorted.sort((a, b) => a.point_order - b.point_order);
                            let stage = 0;
                            for (let i = 0; i < order.length; i++) {
                                console.log('sortable, order', i, order[i], stagesSorted[stage]?.point_order);
                                if (stage < stagesSorted.length && order[i] == stagesSorted[stage].point_order) {
                                    console.log('sortable, stage start', stagesSorted[stage].visible);
                                    if (!stagesSorted[stage].visible) {
                                        let added = 0;
                                        for (let j = (stage < stagesSorted.length - 1 ? order[i+1] : routePoints.length - 1) - 1; j > stagesSorted[stage].point_order; j--) {
                                            if (1 || j > firstSortable) {
                                                order.splice(i + 1, 0, j);
                                                added++;
                                            }
                                        }
                                        i += added;
                                    }
                                    stage++;
                                }
                            }
                            if (order.length == routePoints.length) {
                                for (let i = 1; i < order.length; i++) {
                                    if (!routePoints[order[i]].jobs && !routePoints[order[i-1]].jobs) {
                                        let originalPoints = [...routePoints];
                                        routePoints = [];
                                        $dla = $dla.setRoutePoints(routePoints);
                                        setTimeout(() => {
                                            routePoints = originalPoints;
                                            $dla = $dla.setRoutePoints(routePoints);
                                        }, 0);
                                        return;
                                    }
                                }
                                let newpoints = [];
                                let dirty = false;
                                for (let i = 0; i < order.length; i++) {
                                    if (routePoints[order[i]].point_order != i) {
                                        routePoints[order[i]].point_order = i;
                                        dirty = true;
                                    }
                                    newpoints.push(routePoints[order[i]]);
                                }
                                if (dirty) {
                                    routePoints = newpoints;
                                    routeDirty = true;
                                    $dla = $dla.setRoutePoints(routePoints);
                                    $rsa.getModifiedByOperatorRoute().isLoading = true;
                                    $rsa = $rsa;
                                    Umami.event('route_reorder', { assignment_id: assignment.getId() });
                                    recalcRoute(order);
                                }
                            }
                        }
                    },
                });
            }
        }
    });

    $: console.log('PlanningDeliveryRoute, calculatingRouteInProgress', calculatingRouteInProgress);

    $: {
        console.log(
            'PlanningDeliveryRoute, routeHasBeenChangedAfterCalculation',
            routeHasBeenChangedAfterCalculation
        );
    }

    $: {
        if (assignment.isDownloaded() || assignment.isRouteModifiedAfterDownload()) {
            firstSortable = -2;
            let realisation = assignment.getRealisationStatus(); // assignment?.route_info?.realisation_status;
            console.debug('888, PlanningDeliveryRoute, realisation', realisation);
            // if (realisation && realisation.route_points && routePoints.length) {
            if (realisation && realisation.route_points && routePoints.length) {
                if (planningOnMap) {
                    planningOnMap.updateRealisationStatus(realisation);
                }
                for (let i = 0, ii = realisation.route_points.length; i < ii; i++) {
                    let point = routePoints.filter(
                        p => p.id == realisation?.route_points?.[i].id
                    )[0];
                    if (point) {
                        // point.realisation = realisation?.route_points?.[i]?.details;
                        if (realisation?.route_points?.[i]?.details?.approached || Object.keys(realisation?.route_points?.[i]?.details?.delivered ?? {}).length) {
                            firstSortable = point.point_order;
                        }
                    }
                }
                firstSortable = firstSortable + 2;
                routePoints = routePoints;
            } else {
                console.warn(
                    '888, PlanningDeliveryRoute, realisation not found',
                    realisation?.route_points.length,
                    routePoints.length,
                    $dla.getRoutePoints()
                );
            }
        }
    }

    $: {
        // $deliveryList.isRouteVariantVisible = routeDirty || routeVariant > 0;
        $deliveryList.isRouteVariantVisible = !!modifiedRouteData; //dataIdsDraggedElements.length > 0;
        $deliveryList = $deliveryList;
        console.log(
            '$deliveryList.isRouteVariantVisible, showButtonOptimize',
            $deliveryList.isRouteVariantVisible,
            dataIdsDraggedElements
        );
        // if ($deliveryList.isRouteVariantVisible) {
        //     $rsa.importRouteModifiedByOperator(assignment);
        //     $rsa = $rsa;
        // }
        // if ($deliveryList.isRouteVariantVisible === false) {
        //     dataIdsDraggedElements = [];
        // }
    }

    $: {
        routePoints = JSON.parse(JSON.stringify($dla.getRoutePoints()));
        console.log(
            '888, 777getRoutePoints',
            routePoints.length,
            $dla.getApproachedItems().map(aj => aj.getJobId())
        );

        visiblePoints = [];
        let visibilityArray = [];
        let stageVisible = true;
        for (let i = 0; i < routePoints.length; i++) {
            if (routePoints[i].jobs) {
                if (stageVisible) {
                    visiblePoints.push(routePoints[i]);
                    visibilityArray.push(true);
                } else {
                    visibilityArray.push(false);
                }
            } else {
                stageVisible = stages[routePoints[i].id]?.visible;
                visiblePoints.push(routePoints[i]);
                visibilityArray.push(true);
            }
        }
        if (planningOnMap) {
            planningOnMap.setRoutePointsVisibility(visibilityArray);
        }

        // https://er.automapa.pl/issues/45084
        if (routePoints.length > 0 && routeEndAddress) {
            // get last route point (it should be warehouse or home address)
            let lastPoint = routePoints[routePoints.length - 1];
            routeEndAddress = new Address();
            routeEndAddress.street = lastPoint.address_geocoded?.street || '';
            routeEndAddress.city = lastPoint.address_geocoded?.city || '';
            routeEndAddress.house = lastPoint.address_geocoded?.house || '';
            routeEndAddress.setCoords(
                lastPoint?.geom?.coordinates[0] ?? null,
                lastPoint?.geom?.coordinates[1] ?? null
            );
            routeEndAddress.name = '(' + routeEndAddress.getCoordsAsText() + ')';
        }
    }

    $: {
        // remove duplicated id in routePoints
        routePoints = routePoints.filter(
            (point, index, self) => index === self.findIndex(t => t.id === point.id)
        );
    }

    let minimizeViewTimeWindow: boolean = $leftPageWidthPx < 600;
    $: minimizeViewTimeWindow = $leftPageWidthPx < 600;
</script>

{#if $dla.loading}
    <div style="min-height: 100px;">
        <Spinner />
    </div>
{:else if error}
    <MessageDanger header={error} />
{:else}
    {#if $debug}
        routeDirty: {routeDirty ? 'true' : 'false'}
        routeVariant: {routeVariant}
        dataIdsDraggedElements: {JSON.stringify(dataIdsDraggedElements)}
    {/if}

    {#if calculatingRouteInProgress || routePoints.length < 2}
        <div style="min-height: 100px;">
            <Spinner />
        </div>
    {:else if routePoints.length > 2}
        <div style="padding-right:15px;">
            <AssignmentJobOneHeader
                bind:assignment
                showCheckbox={false}
                displayMode="routePoint"
                {minimizeViewTimeWindow}
            />
        </div>
    {/if}

    {#if routePoints.length > 2}
        <div
            class="project-list"
            class:list-disabled={calculatingRouteInProgress}
            bind:this={projectList}
        >
            <div
                class="route-point-row"
                data-id={0}
                on:click={(e) => {
                    if (!e.target.closest('.other')) {
                        onStageToggle(routePoints[0].point_order, !stages[routePoints[0].id].visible);
                    }
                }}
                on:dblclick={() => {
                    onStageShowExclusive(routePoints[0].point_order);
                }}
            >
                <AssignmentJobOneWarehouse
                    bind:assignment
                    routePointIndex={0}
                    eta_seconds={assignment.getStartHourRouteInSeconds()}
                    address={warehouseAddress}
                    displayShape="single-first"
                    {minimizeViewTimeWindow}
                    expandable={Object.keys(stages).length > 1}
                    expanded={stages[routePoints[0].id]?.visible}
                    onToggle={onStageToggle}
                />
            </div>

            {#each visiblePoints as routePoint, index (routePoint.id)}
                {#if routePoint.address_id}
                    <div
                        class="route-point-row"
                        in:blur|global
                        data-id={routePoint.point_order.toString()}
                        data-route-point-id={routePoint.id}
                        class:point-draggable={isRoutePointDraggable(routePoint)}
                        class:point-dragged={dataIdsDraggedElements.includes(routePoint.id)}
                        on:mousemove={onRoutePointMouseMove}
                        on:mouseleave={onRoutePointMouseLeave}
                    >
                        <RoutePointWithAssignments
                            {disabled}
                            bind:routePoint
                            bind:assignment
                            bind:modifiedRouteData
                            {routeDirty}
                            {planningOnMap}
                            bind:expandedIndex={$deliveryList.expandedIndex}
                            {minimizeViewTimeWindow}
                        />
                    </div>
                {:else if (routePoint.point_order > 0 && routePoint.point_order < routePoints.length - 1 && routePoint.geom.coordinates.join(',') == routePoints[0].geom.coordinates.join(','))}
                    <div
                        class="route-point-row"
                        in:blur|global
                        data-id={routePoint.point_order.toString()}
                        data-route-point-id={routePoint.id}
                        class:point-draggable={isRoutePointDraggable(routePoint)}
                        class:point-dragged={dataIdsDraggedElements.includes(routePoint.id)}
                        on:click={(e) => {
                            if (!e.target.closest('.other')) {
                                onStageToggle(routePoint.point_order, !stages[routePoint.id].visible);
                            }
                        }}
                        on:dblclick={() => {
                            onStageShowExclusive(routePoint.point_order);
                        }}
                    >
                        <AssignmentJobOneWarehouse
                            bind:assignment
                            routePointIndex={routePoint.point_order}
                            eta_seconds={((modifiedRouteData?.deltas?.[routePoint.point_order]?.g.m || routePoint.delta?.g.m) || 0)*60}
                            address={warehouseAddress}
                            displayShape="single-first"
                            {minimizeViewTimeWindow}
                            {routeDirty}
                            removable={!disabled}
                            onRemove={(routePointIndex) => {
                                onRemoveWarehouse(routePointIndex);
                            }}
                            expandable={true}
                            expanded={stages[routePoint.id]?.visible}
                            onToggle={onStageToggle}
                        />
                    </div>
                {/if}
            {/each}

            <div class="route-point-row" data-id={routePoints.length-1}>
                {#if routeEndAddress}
                    <AssignmentJobOneWarehouse
                        bind:assignment
                        routePointIndex={routePoints.length + 1}
                        eta_seconds={assignment.getEndHourRouteInSeconds()}
                        address={routeEndAddress}
                        displayShape="single-last"
                        simpleView={false}
                        {minimizeViewTimeWindow}
                        {routeDirty}
                    />
                {:else}
                    <AssignmentJobOneWarehouse
                        bind:assignment
                        routePointIndex={routePoints.length + 1}
                        eta_seconds={assignment.getEndHourRouteInSeconds()}
                        address={warehouseAddress}
                        displayShape="single-last"
                        {minimizeViewTimeWindow}
                        {routeDirty}
                    />
                {/if}
            </div>
        </div>
    {/if}
{/if}

<style>
    .project-list {
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
        padding-right: 15px;
    }
    .list-disabled {
        pointer-events: none;
        opacity: 0.4;
        visibility: hidden;
    }
    .point-dragged {
        /*background-color: antiquewhite;*/
        background-color: #e5e3e3;
    }
    :global(.insert-warehouse) {
        position: absolute;
        left: 0;
        height: 20px;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 12px;
        color: #4978e2;
        background-color: #ffffffdd;
        border-radius: 2px;
        padding: 1px 3px 1px 0;
    }
    :global(.insert-warehouse div) {
        white-space: nowrap;
    }
    :global(.insert-warehouse .line) {
        flex: 1;
        width: 30px;
        height: 0;
        border-top: 1px dashed #4978e2;
        border-bottom: 1px dashed #4978e2;
    }
    :global(.insert-warehouse .circle) {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 18px;
        height: 18px;
        border: 1px solid #4978e2;
        border-radius: 9px;
        text-align: center;
        font-size: 12px;
    }
</style>
